import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

export default function useMobileBreakpoint() {
  const screens = useBreakpoint();

  return !screens.lg;
}
